import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaExclamationCircle, FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import '../../styles/Notification.css';

const Notification = ({ message, type = 'success', onClose }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Start exit animation 4.5 seconds after mounting (0.3s before auto-close)
    const exitTimer = setTimeout(() => {
      setIsExiting(true);
    }, 4500);

    // Close the notification after exit animation completes
    const closeTimer = setTimeout(() => {
      onClose();
    }, 4800);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(closeTimer);
    };
  }, [onClose]);

  const handleClose = () => {
    setIsExiting(true);
    // Wait for exit animation to complete before calling onClose
    setTimeout(() => onClose(), 300);
  };

  if (!message) return null;

  const getIcon = () => {
    switch (type) {
      case 'error':
        return <FaExclamationCircle className="notification-icon" />;
      case 'warning':
        return <FaExclamationTriangle className="notification-icon" />;
      case 'success':
      default:
        return <FaCheckCircle className="notification-icon" />;
    }
  };

  return (
    <div className={`notification ${type} ${isExiting ? 'exiting' : ''}`}>
      <div className="notification-content">
        {getIcon()}
        <span className="notification-message">{message}</span>
        <button 
          className="notification-close" 
          onClick={handleClose}
          aria-label="Close notification"
        >
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

export default Notification;
